



























import { Component, Prop, Vue } from 'vue-property-decorator';
import AuthenticatedNav from '@classes/AuthenticatedNav';
import DesktopNavTemplate from '@components/header/navigation/desktop/desktop-nav-template.vue';
import { HeaderStyle } from 'types/header';
import { investmentEntity } from '@store/modules/investment-entity';
import { InvestmentEntity } from 'types/investment-entity';
import NavigationLinkDesktop from './navigation-link-desktop.vue';
import NotificationDropdown from '@components/header/navigation/notification-dropdown.vue';
import { user } from '@store/modules/user';
import UserDropdown from '@components/header/navigation/user-dropdown.vue';
@Component({
	components: {
		DesktopNavTemplate,
		NavigationLinkDesktop,
		NotificationDropdown,
		UserDropdown
	}
})
export default class DesktopNavAuth extends Vue {
	@Prop()
	private styles!: HeaderStyle;

	isInvestTabEnabled = true;
	userDropdownExpanded = false;
	notificationDropdownExpanded = false;

	get investmentEntityObject(): InvestmentEntity {
		return investmentEntity.investmentEntityObject;
	}

	get investTabEnabled(): boolean {
		return !this.investmentEntityObject.isIraEntity && this.isInvestTabEnabled;
	}

	get hasMultipleEntities(): boolean {
		return this.nav.multipleInvestmentEntities;
	}

	get nav(): AuthenticatedNav {
		return new AuthenticatedNav(user.user, this.investmentEntityObject, this.investTabEnabled);
	}

	expandNotificationDropdown(expanded: boolean) {
		this.notificationDropdownExpanded = expanded;
		if (expanded && this.userDropdownExpanded) {
			this.userDropdownExpanded = false;
		}
	}

	expandUserDropdown(expanded: boolean) {
		this.userDropdownExpanded = expanded;
		if (expanded && this.notificationDropdownExpanded) {
			this.notificationDropdownExpanded = false;
		}
	}
}
